<template>
  <div class="searchable-table-container">
    <search-form
      :search-form="searchParams"
      :search-form-change="searchParamChange"
    />
    <basic-table
      :table-data="tableData"
      :table-headers="tableHeaders"
      :has-actions="hasActions"
      :action-min-width="actionMinWidth"
      :action-width="actionWidth"
      :has-row-expand="hasRowExpand"
      :header-height="headerHeight"
      :row-height="rowHeight"
      :selectable="selectable"
      :pagination-change="searchParamChange"
      :sort-change="sortChange"
      :rowClassName="rowClassName"
      :stripe="stripe"
    >
      <template v-slot:row-expand="props">
        <slot
          name="row-expand"
          v-bind:row="props.row"
          v-bind:index="props.index"
        >
        </slot>
      </template>
      <template v-slot:row-actions="props" v-if="hasActions">
        <slot name="actions" v-bind:row="props.row" v-bind:index="props.index">
        </slot>
      </template>
      <template v-for="name in headerSlots" v-slot:[name]="props">
        <slot
          class="test-class"
          :name="name"
          v-bind:row="props.row"
          v-bind:index="props.index"
        >
        </slot>
      </template>
    </basic-table>
  </div>
</template>

<script>
import { SlotType, PageSortKey } from '@/core/configs/types'
import SearchForm from '@/components/common/SearchForm.vue'
import BasicTable from '@/components/common/BasicTable.vue'

export default {
  name: 'SearchableTable',
  components: {
    SearchForm,
    BasicTable
  },
  props: {
    tableHeaders: {
      type: Array,
      default: () => []
    },
    tableData: {
      type: Object,
      default: () => ({
        data: [],
        total: 0,
        pageSize: 20,
        curPage: 1
      })
    },
    searchParams: {
      type: Object,
      default: () => {}
    },
    searchParamChange: {
      type: Function,
      default: () => {}
    },
    hasActions: {
      type: Boolean,
      default: false
    },
    actionMinWidth: {
      type: Number,
      default: 120
    },
    actionWidth: {
      type: Number,
      default: 120
    },
    hasRowExpand: {
      type: Boolean,
      default: false
    },
    checkExpand: {
      type: Function,
      default: () => false
    },
    headerHeight: {
      type: Number,
      default: 50
    },
    rowHeight: {
      type: Number,
      default: 50
    },
    selectable: {
      type: Boolean,
      default: false
    },
    rowClassName: {
      type: Function,
      default: () => {}
    },
    stripe: {
      ttype: Boolean,
      default: true
    }
  },
  data() {
    return {
      pagination: {
        pageSize: 10,
        curPage: 1
      },
      inCartCount: 'inCartCount'
    }
  },
  computed: {
    pageTableData() {
      const end = this.pagination.curPage * this.pagination.pageSize
      const start = end - this.pagination.pageSize
      return this.tableData.slice(start, end)
    },
    headerSlots() {
      const a = this.tableHeaders
        .filter(one => one.type === SlotType)
        .map(one => one.slotName)
      return a
    }
  },
  methods: {
    sortChange(item) {
      this.searchParamChange(PageSortKey, 'value', item)
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.table-container {
  margin-top: 10px;
  border-radius: 3px;

  .pagination {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}

.actions-container {
  flex-wrap: wrap;
  gap: 10px;

  @extend .f-r;
}

.action-button {
  padding: 0;
  margin: 0 !important;
}
</style>
